<template>
    <div class="file-upload">
        <div class="tabs">
            <!-- <div
                :class="['tab-item', selectTab === 0 ? 'active' : '']"
                @click="changeTab(0)"
            >文件上传</div> -->
            <div
                v-if="isShowTitle"
                :class="['tab-item', selectTab === 1 ? 'active' : '']"
                @click="changeTab(1)"
            >文本上传</div>
        </div>
        <div class="content">
            <!-- 文件上传 -->
            <div
                v-show="selectTab === 0"
                class="file-upload-content"
                @dragover.prevent
                @dragenter.prevent
                @drop="handleDrop"
            >
                <div
                    v-show="!fileList || !fileList.length"
                    class="upload-steps"
                >
                    <div class="upload-icon"></div>
                    <div>第一步：下载模板，填写内容</div>
                    <div class="second-steps">
                        第二步：拖拽文件或
                        <div class="upload-btn">点击上传
                            <veui-uploader
                                ref="uploader"
                                type="file"
                                max-size="30mb"
                                :max-count="20"
                                :multiple="true"
                                accept=".xlsx,.xls"
                                :convert-response="convertResponse"
                                :action="`${url}&bucketName=law_smart&storeDir=honorary_licence&ajax=true`"
                                @success="success"
                                @failure="failure"
                            />
                        </div>
                    </div>
                    <div class="file-upload-content-tips">
                        <p>单次最多上传20个文件（仅支持excel文件）单个大小30MB，请根据提供的模板格式进行文件上传</p>
                        <p style="margin-top: 6px;">请注意确保您上传的知识内容合法合规，且不存在侵犯他人合法权益的情形。</p>
                    </div>
                    <!-- 模板 -->
                    <div class="template">
                        <div v-if="type !== 'question'" class="template-btn">
                            <span class="icon"></span>
                            下载案例内容标准模版
                        </div>
                        <div v-if="type !== 'case'" class="template-btn">
                            <span class="icon"></span>
                            下载问答语料标准模版
                        </div>
                    </div>
                </div>
                <div v-show="fileList && fileList.length">
                    <!-- 文件列表 -->
                    <div class="file-list">
                        <div
                            v-for="item, index in fileList"
                            :key="item.key"
                            class="file-item"
                        >
                            <div class="file-name">
                                {{ item.name }}
                            </div>
                            <div class="delete-icon" @click="handleDelete(index)"></div>
                            <div v-if="item.src && item.timer < 100" class="file-process">
                                <veui-progress
                                    :value="item.timer"
                                    :min="0"
                                    :max="100"
                                    desc
                                />
                                <div class="process-text">上传中...</div>
                            </div>
                            <div v-if="!item.src" class="file-process error">
                                <veui-progress
                                    :value="50"
                                    :min="0"
                                    :max="100"
                                    status="error"
                                    desc
                                />
                                <div class="process-text">上传失败</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="uplate-box"
                    >
                        <div class="btn" @click="submit">确认上传</div>
                        <div class="upload-tips">将文件拖拽到此处，或
                            <div class="upload-btn">点击上传
                                <veui-uploader
                                    ref="uploader"
                                    type="file"
                                    max-size="30mb"
                                    :max-count="20"
                                    accept=".xlsx,.xls"
                                    :multiple="true"
                                    :convert-response="convertResponse"
                                    :action="`${url}&bucketName=law_smart&storeDir=honorary_licence&ajax=true`"
                                    @success="success"
                                    @failure="failure"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 文本上传 -->
            <div v-show="selectTab === 1" class="text-upload-content">
                <div v-if="!type" class="type-checkbox">
                    <div class="label">案例标题</div>
                    <veui-radio
                        v-for="({value, label}) in types"
                        :key="value"
                        v-model="contentType"
                        class="radio"
                        :value="value"
                    >
                        {{ label }}
                    </veui-radio>
                </div>
                <div class="add-box">
                    <div class="add-box-title">{{ typeName }}上传步骤：</div>
                    <div class="add-box-tips">
                        <div>1.请点击下方入口进行{{ typeName === '问答语料' ? '问答内容' : typeName }}填写</div>
                        <div>2.发布成功后系统将自动同步该{{ typeName === '问答语料' ? '问答内容' : typeName }}至智能体知识库</div>
                        <div>3.回到知识库-{{ typeName }}设置页查看新同步的{{ typeName === '问答语料' ? '问答内容' : typeName }}</div>
                    </div>
                    <div class="add-btn" @click="addContent">去添加{{ contentType === '1' ? '问答' : '案例' }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 文件上传组件
import {Uploader, Radio, Progress} from 'veui';
export default {
    name: '',
    components: {
        'veui-uploader': Uploader,
        'veui-radio': Radio,
        'veui-progress': Progress
    },
    data() {
        return {
            selectTab: 1,
            url: '/bp/api/upload?ajax=1&bdstoken=',
            types: [
                {value: '0', label: '案例内容'},
                {value: '1', label: '问答语料'}
            ],
            contentType: '0',
            fileList: [] // 用于展示用
        };
    },
    props: {
        // 上传类型：case案例还是question语料，不传默认都包含
        type: {
            type: String,
            default: ''
        },
        isShowTitle: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        fileList: {
            handler() {
            },
            deep: true,
            immediate: true
        },
        type: {
            handler(val) {
                if (val === 'question') {
                    this.contentType = '1';
                }
                if (val === 'case') {
                    this.contentType = '0';
                }
            },
            immediate: true
        }
    },
    computed: {
        typeName() {
            return this.types[+this.contentType]?.label || '';
        }
    },
    methods: {
        changeTab(val) {
            if (val !== this.selectTab) {
                this.selectTab = val;
            }
        },
        convertResponse(data) {
            return ({
                success: data && (Number(data.code) === 0),
                src: data && data.data && data.data.bos_url,
                message: data.msg
            });
        },
        // 文件上传成功
        success(file) {
            if (file.src) {
                file.timer = 0; // 假设5秒后文件上传成功
                const interval = setInterval(() => {
                    if (file.timer > 100) {
                        clearInterval(interval);
                        file.timer = 100;
                    }
                    else {
                        file.timer += Math.random() * 10; // 随机增加进度
                    }
                }, 30);
            }
            this.fileList.push(file);
        },
        // 文件上传失败
        failure(file) {
            this.fileList.push(file);
        },
        /**
         * 拖拽事件处理
         */
        handleDrop(event) {
            event.preventDefault(); // 阻止默认行为（比如某些文件预览）
            event.stopPropagation(); // 阻止事件冒泡

            // 提取拖放的文件
            const fileList = event.dataTransfer.files;
            let list = [];

            // 这里可以添加对文件的处理逻辑，比如预览或上传到服务器
            // 例如，这里我们简单地将文件名打印到控制台
            if (fileList.length > 0) {
                Array.from(fileList).forEach(file => {
                    if (file.name?.split('.')?.pop() === 'xls' || file.name.split('.').pop() === 'xlsx') {
                        list.push(file);
                    }
                    else {
                        this.$toast.error('您上传的文件不符合格式要求，请重新上传');
                    }
                });
                this.$refs.uploader.addFiles(list);
            }
        },
        addContent() {
            this.$emit(this.contentType === '0' ? 'addCase' : 'addQa', {isOpenOldEdit: true});
        },

        /**
         * 删除文件
         */

        handleDelete(index) {
            this.fileList.splice(index, 1);
        },
        // 文件提交
        submit() {
            this.$toast.success('文件上传成功');
            this.$emit('showRecentUpload');
        }
    }
};
</script>

<style lang='less' scoped>
.file-upload {
    .tabs {
        display: flex;

        .tab-item {
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #1e1f24;
            line-height: 16px;
            margin-right: 48px;
            cursor: pointer;

            &.active {
                color: #05f;
            }
        }
    }

    .content {
        .file-upload-content {
            background: #f4f9ff;
            border-radius: 8px;
            border: 1px dashed #e4e4e4;
            text-align: center;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #1e1f24;
            line-height: 14px;

            .upload-steps {
                padding: 30px 0 33px;
            }

            .upload-icon {
                width: 50px;
                height: 38px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/update.png") no-repeat center / 100% 100%;
                margin: 0 auto 24px;
            }

            .second-steps {
                display: flex;
                justify-content: center;
                margin-top: 12px;

                .upload-btn {
                    position: relative;
                    color: #05f;
                    cursor: pointer;

                    /deep/.veui-uploader {
                        width: 56px;
                        height: 14px;
                        position: absolute;
                        top: 0;
                        z-index: 1;
                        opacity: 0;
                    }
                }
            }

            .file-upload-content-tips {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #848691;
                line-height: 12px;
                text-align: center;
                margin-top: 18px;
            }

            .template {
                display: flex;
                justify-content: center;

                .template-btn {
                    width: 197px;
                    height: 38px;
                    background: #fff;
                    border-radius: 4px;
                    border: 1px solid #e4e4e4;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #05f;
                    line-height: 1;
                    margin-top: 23px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:not(:last-child) {
                        margin-right: 30px;
                    }

                    .icon {
                        width: 14px;
                        height: 15px;
                        display: inline-block;
                        margin-right: 3px;
                        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/download.png") no-repeat center / contain;
                    }
                }
            }

            .file-list {
                display: grid;
                grid-template-columns: 1fr 1fr;
                border-bottom: 1px solid rgba(228, 228, 228, .5);
                // 奇数行
                .file-item:nth-child(odd) {
                    border-right: 1px solid rgba(228, 228, 228, .5); /* 网格项内边框 */
                }

                .file-item {
                    text-align: left;
                    padding: 24px;
                    display: flex;
                    position: relative;
                    border-top: 1px solid rgba(228, 228, 228, .5); /* 网格项内边框 */

                    .file-name {
                        max-width: 178px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .delete-icon {
                        height: 14px;
                        width: 14px;
                        margin-left: 30px;
                        cursor: pointer;
                        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/delete-icon.png") no-repeat center / 100% 100%;
                    }

                    .file-process {
                        position: absolute;
                        right: 26px;
                        width: 177px;
                        display: flex;
                        justify-content: space-between;

                        &.error {
                            /deep/.veui-progress {
                                .veui-progress-rail {
                                    background: rgba(255, 59, 46, .15);
                                }

                                .veui-progress-meter {
                                    background-color: rgba(255, 59, 46, 1);
                                }
                            }
                        }

                        /deep/.veui-progress {
                            .veui-progress-desc {
                                display: none;
                            }

                            .veui-progress-meter {
                                border-radius: 5px;
                            }
                        }

                        /deep/.veui-progress-rail {
                            width: 109px;
                            height: 6px;
                            border-radius: 5px;
                        }
                    }
                }

                :nth-child(1),
                :nth-child(2) {
                    border-top: none;
                }
            }

            .uplate-box {
                background: #fff;
                display: flex;
                align-items: center;
                padding-left: 23px;
                padding-top: 12px;
                padding-bottom: 12px;
                border-radius: 0 0 8px 8px;

                .btn {
                    width: 96px;
                    height: 40px;
                    background: #05f;
                    border-radius: 5px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #fff;
                    line-height: 40px;
                    text-align: center;
                    cursor: pointer;
                }

                .upload-tips {
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #878787;
                    line-height: 20px;
                    margin-left: 28px;
                    display: flex;

                    .upload-btn {
                        position: relative;
                        color: #05f;
                        cursor: pointer;

                        /deep/.veui-uploader {
                            width: 56px;
                            height: 14px;
                            position: absolute;
                            top: 0;
                            z-index: 1;
                            opacity: 0;
                        }
                    }
                }
            }
        }

        .text-upload-content {
            .type-checkbox {
                display: flex;
                padding-top: 18px;

                .label {
                    margin-right: 24px;
                    position: relative;
                    padding-right: 13px;

                    &::after {
                        content: "";
                        position: absolute;
                        display: inline-block;
                        top: 4.5px;
                        right: 0;
                        height: 9px;
                        width: 9px;
                        background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/role-set/bixuan.png) no-repeat center center / 100% 100%;
                    }
                }

                /deep/.radio {
                    margin-right: 30px;

                    .veui-radio-label {
                        color: #1e1f24;
                        font-weight: 500;
                    }
                }
            }

            .add-box {
                margin-top: 18px;
                height: 258px;
                background: #f4f9ff;
                border-radius: 8px;
                border: 1px solid #e4e4e4;
                text-align: center;
                padding: 45px 0;

                .add-box-title {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #1e1f24;
                    line-height: 16px;
                    text-align: center;
                }

                .add-box-tips {
                    margin-top: 18px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #848691;
                    line-height: 24px;
                    text-align: center;
                }

                .add-btn {
                    width: 120px;
                    height: 38px;
                    background: #fff;
                    border-radius: 4px;
                    border: 1px solid #e4e4e4;
                    margin: 24px auto 0;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #05f;
                    line-height: 38px;
                    text-align: center;
                    cursor: pointer;
                    position: relative;
                    padding-right: 12px;

                    &::after {
                        content: "";
                        position: absolute;
                        width: 11px;
                        height: 6px;
                        margin-left: -2px;
                        transform: rotate(90deg) translateY(-50%);
                        top: 43%;
                        background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/role-set/blue-arrow.png) no-repeat center / 100% 100%;
                    }
                }
            }
        }
    }
}
</style>
